import React from 'react';

const ProgressBar = ({ goal, raised, showLegend = true }) => {
  const stripeFeeRate = 0.022;
  const stripeFeeFixed = 0.30;
  
  const calculateStripeFees = (amount) => {
    return (amount * stripeFeeRate) + stripeFeeFixed;
  };

  const feesNeeded = calculateStripeFees(goal);
  const totalPersonalNeeded = goal + feesNeeded;
  const teamContribution = Math.max(0, raised - totalPersonalNeeded);
  const personalProgress = Math.min(raised, totalPersonalNeeded);
  
  const personalPercentage = Math.min((personalProgress / totalPersonalNeeded) * 100, 100);
  const teamPercentage = teamContribution > 0 ? 20 : 0; // Show team contribution as additional segment
  
  const totalDisplayAmount = raised + (teamContribution > 0 ? feesNeeded : 0);
  const maxDisplayAmount = totalPersonalNeeded + (teamContribution > 0 ? teamContribution : 0);

  return (
    <div className="w-full">
      <div className="flex justify-between text-xs sm:text-sm text-gray-600 mb-1 sm:mb-2">
        <span>Progress: ${raised.toLocaleString()}</span>
        <span>Goal: ${goal.toLocaleString()}</span>
      </div>

      <div className="w-full bg-gray-200 rounded-full h-5 sm:h-6 overflow-hidden">
        <div className="flex h-full">
          <div 
            className="bg-emerald-500 transition-all duration-300 ease-out"
            style={{ width: `${personalPercentage}%` }}
          ></div>
          {teamContribution > 0 && (
            <div 
              className="bg-sky-500 transition-all duration-300 ease-out"
              style={{ width: `${teamPercentage}%` }}
            ></div>
          )}
        </div>
      </div>

      <div className="flex justify-between text-xs text-gray-500 mt-1">
        <span>${personalProgress.toLocaleString()} / ${totalPersonalNeeded.toLocaleString()}</span>
        {teamContribution > 0 && (
          <span className="text-sky-600">+${teamContribution.toLocaleString()} team fund</span>
        )}
      </div>

      {showLegend && (
        <div className="mt-3 sm:mt-4 space-y-1 sm:space-y-2">
          <h4 className="font-semibold text-xs sm:text-sm text-gray-700">Progress Breakdown:</h4>
          <div className="space-y-1 text-xs sm:text-sm">
            <div className="flex items-center">
              <div className="w-4 h-4 bg-emerald-500 rounded mr-2"></div>
              <span className="text-gray-600">
                Personal Goal (${goal.toLocaleString()}) + Fees (${feesNeeded.toFixed(2)}) = ${totalPersonalNeeded.toLocaleString()}
              </span>
            </div>
            {teamContribution > 0 && (
              <div className="flex items-center">
                <div className="w-4 h-4 bg-sky-500 rounded mr-2"></div>
                <span className="text-gray-600">
                  Team Contribution: ${teamContribution.toLocaleString()}
                </span>
              </div>
            )}
          </div>
          <div className="text-xs text-gray-500 mt-2">
            *Stripe fees: 2.2% + $0.30 per transaction
          </div>
        </div>
      )}
    </div>
  );
};

export default ProgressBar;